import './WorkerSelector.scss';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_PickySelect } from '../../../../../../../design/inputs/select/S_PickySelect';
import { IWorker } from '../../ProjectStatsFilters.store';

interface IProps {
  availableWorkers: IWorker[];
  selectedWorkers: IWorker[];
  onWorkersChange: (workers: IWorker[]) => void;
}

export const WorkerSelector = observer((props: IProps): ReactElement => {
  const { availableWorkers, selectedWorkers, onWorkersChange } = props;

  const handleChange = (selected: string[]): void => {
    onWorkersChange(availableWorkers.filter((w) => selected.some((s) => s === w.id)));
  };

  const options = availableWorkers.map((w) => ({ label: w.email, value: w.id }));
  const selected = selectedWorkers.map((s) => s.id);

  return (
    <S_PickySelect
      className='worker-selector'
      options={options}
      value={selected}
      onChange={(_, v) => {
        handleChange(v);
      }}
    />
  );
});
